import React from "react"

const Switch = ({ label, toggle, onToggleClick }) => {
	const toggleClass = "transform translate-x-5"
	return (
		<>
			<div className="flex flex-row">
				<div className="flex flex-col justify-center items-center">
					<div
						className={`md:w-12 md:h-6 w-8 h-5 flex items-center ${
							toggle ? "bg-green-400" : "bg-gray-400"
						}  rounded-full p-1 cursor-pointer`}
						onClick={() => onToggleClick?.()}
					>
						<div
							className={
								"bg-black md:w-5 md:h-5 h-5 w-5 rounded-full shadow-md transform duration-300 ease-in-out" +
								(toggle ? toggleClass : null)
							}
						></div>
					</div>
				</div>
				<div className="ml-2">{label}</div>
			</div>
		</>
	)
}

export default Switch
